module.exports = __webpack_public_path__ + "img/pol.0930044f.png";